import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };
 
  return axios.get(`${url}/workshop/workshop_pkbs`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_pkbs/${id}`, options)
    .then(response => {
      let pkb = jsona.deserialize(response.data);
      delete pkb.links;
      return pkb;
    });
}

function add(pkb) {
  
  console.log(pkb);
  const payload = jsona.serialize({
    stuff: pkb,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_pkbs`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(pkb) {
  const payload = jsona.serialize({
    stuff: pkb,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_pkbs`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update_status(pkbs) {
  const payload = jsona.serialize({
    stuff: pkbs,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_pkbs/update_status/${pkbs.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_pkbs/${id}`, options);
}

// function partTable() {
//   const options = {
//     headers: {
//       'Accept': 'application/vnd.api+json',
//       'Content-Type': 'application/vnd.api+json',
//     }
//   };

//   return axios.get(`${url}/workshop/workshop_pkbs/part/table`, options)
//     .then(response => {
//       //let dashboard = jsona.deserialize(response.data);
//       return response.data;
//     });
// }

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_pkbs/last/no`, options)
    .then(response => {
      return response.data;
    });
}

export default {
  list,
  get,
  add,
  update,
  update_status,
  destroy,
  last_no,
  // partTable
};

